import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap"

const TeamMemberModal = props => {
  const { isOpen, toggle, member } = props
  {
    if (member !== null)
      return (
        <>
          <Modal
            isOpen={isOpen}
            role="dialog"
            autoFocus={true}
            centered={true}
            className="teamMemberModal"
            tabIndex="-1"
            toggle={toggle}
          >
            <ModalHeader toggle={toggle}>Member Details</ModalHeader>
            <ModalBody>
              <Table>
                <tbody>
                  <tr>
                    <th>Role</th>
                    <td>{member.at_role}</td>
                  </tr>
                  <tr>
                    <th>Full Name</th>
                    <td>{member.at_fullName}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{member.at_email}</td>
                  </tr>
                  <tr>
                    <th>Phone Number</th>
                    <td>{member.at_phoneNumber}</td>
                  </tr>
                  <tr>
                    <th>Alt. Phone Number</th>
                    <td>{member.at_altPhoneNumber}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{member.at_status ? "Active" : "Inactive"}</td>
                  </tr>
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
        </>
      )
  }
}

TeamMemberModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default TeamMemberModal
